import { axiosInstance } from "./AxiosInterceptor";
import { backendConfig } from "../config/BackendConfig";

/**
 * @param {
 *   requestedUserId: string,
 *   siteId: string,
 *   scheduleName: string
 * } queryParam
 * @returns Promise
 */
export const validateScheduleTemplateName = (queryParam) => {
  /**End Point:- validateScheduleTemplateName**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.validateScheduleTemplateName,
    queryParam
  );
};

/**
 * @param {
 *   requestedUserId: string,
 *   siteId: string,
 *   scheduleName: string
 *   scheduleDescription: string
 *   scheduleDurationType: string   "DAILY|WEEKLY"
 *   jobList: array      [jobTime:"30 12 * * *" , targetMode:"STANDBY|OPERATIONAL|SENSEONLY"]
 *   userTimezone: string
 * } queryParam
 * @returns Promise
 */
export const createScheduleTemplate = (queryParam) => {
  /**End Point:- createScheduleTemplate**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.createScheduleTemplate,
    queryParam
  );
};

/**
 * @param {
 *   requestedUserId: string,
 *   scheduleId: string,
 *   scheduleName: string
 *   scheduleDescription: string
 *   scheduleDurationType: string   "DAILY|WEEKLY"
 *   jobList: array      [jobTime:"30 12 * * *" , targetMode:"STANDBY|OPERATIONAL|SENSEONLY"]
 *   userTimezone: string
 * } queryParam
 * @returns Promise
 */
export const editScheduleTemplate = (queryParam) => {
  /**End Point:- editScheduleTemplate**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.editScheduleTemplate,
    queryParam
  );
};

/**
 * @param {
 *   requestedUserId: string,
 *   siteId: string,
 *   pageNo: number,
 *   size: number,
 *   sort: [{"createdDateTime": "DESC"}, { "scheduleName": "ASC" }]         //Optional
 *   search: string,     //Optional
 * } queryParam
 * @returns Promise
 */
export const getScheduleTemplates = (queryParam) => {
  /**End Point:- getScheduleTemplates**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getScheduleTemplates,
    queryParam
  );
};

/**
 * @param {
 *   requestedUserId: string,
 *   siteId: string,
 *   pageNo: number,
 *   size: number,
 *   sort: [{"createdDateTime": "DESC"}, { "scheduleName": "ASC" }]         //Optional
 *   search: string,     //Optional
 * } queryParam
 * @returns Promise
 */
export const getSchedules = (queryParam) => {
  /**End Point:- getSchedules**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getSchedules,
    queryParam
  );
};

/**
 * @param {
 *   requestedUserId: string,
 *   scheduleId: string,
 *   deviceId: string
 *   action: string
 * } queryParam
 * @returns Promise
 */

export const performScheduleOperation = (queryParam) => {
  /**End Point:- performScheduleOperation**/
  return axiosInstance.post(
    backendConfig.API_URL +
      backendConfig.API_END_POINTS.performScheduleOperation,
    queryParam
  );
};

/**
 * @param {
 *   scheduleId: scheduleUUID
 * } queryParam
 * @returns Promise
 */

export const deleteScheduleTemplate = (queryParam) => {
  /**End Point:- deleteScheduleTemplate**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.deleteScheduleTemplate,
    queryParam
  );
};


export const pushSchedule = (queryParam) => {
  /**End Point:- pushSchedule**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.pushSchedule,
    queryParam
  );
};


export const getDevicesForFleetDashboard = (queryParam) => {
  /**End Point:- getDevicesForFleetDashboard**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getDevicesForFleetDashboard,
    queryParam
  );
};


export const performFleetSchedule = (queryParam) => {
  /**End Point:- performFleetSchedule**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.performFleetSchedule,
    queryParam
  );
};

export const getFleetScheduleOperationDetails = (queryParam) => {
  /**End Point:- getFleetScheduleOperationDetails**/
  return axiosInstance.post(
    backendConfig.API_URL + backendConfig.API_END_POINTS.getFleetScheduleOperationDetails,
    queryParam
  );
};